/** Skeleton placeholder for the teacher overview while dashboard data loads. */
export function TeacherOverviewSkeleton() {
  return (
    <div className="overview-skeleton" aria-busy="true" aria-label="Loading overview">
      <div className="submissions-kpi-grid overview-kpi-grid">
        {[0, 1, 2, 3, 4].map((i) => (
          <div key={i} className="overview-skeleton-kpi">
            <div className="skeleton skeleton--line skeleton--line-sm" />
            <div className="skeleton overview-skeleton-kpi-value" />
            <div className="skeleton skeleton--line skeleton--line-md" />
          </div>
        ))}
      </div>

      <div className="overview-main-grid">
        <section className="submissions-chart-panel overview-pulse-panel">
          <div className="skeleton skeleton--panel-title skeleton--panel-title-wide" />
          <div className="skeleton skeleton--line skeleton--line-md" style={{ marginBottom: "0.85rem" }} />
          <div className="overview-skeleton-pulse-list">
            {[0, 1, 2].map((i) => (
              <div key={i} className="overview-skeleton-pulse-row">
                <div className="skeleton skeleton--line skeleton--line-lg" />
                <div className="skeleton skeleton--line skeleton--line-sm" />
                <div className="skeleton overview-skeleton-track" />
              </div>
            ))}
          </div>
        </section>

        <div className="overview-side-col">
          <section className="submissions-chart-panel">
            <div className="skeleton skeleton--panel-title" />
            <div className="skeleton skeleton--line skeleton--line-sm" style={{ marginBottom: "0.85rem" }} />
            <div className="skeleton overview-skeleton-donut" />
          </section>
          <section className="submissions-chart-panel">
            <div className="skeleton skeleton--panel-title" />
            <div className="skeleton skeleton--line skeleton--line-sm" style={{ marginBottom: "0.85rem" }} />
            {[0, 1, 2].map((i) => (
              <div key={i} className="overview-skeleton-deadline-row">
                <div className="skeleton overview-skeleton-chip" />
                <div className="skeleton skeleton--line skeleton--line-lg" />
              </div>
            ))}
          </section>
        </div>
      </div>
    </div>
  );
}
